const LS_KEY = "isp_token_1";

export default function getUserSession() {
    if (LS_KEY in localStorage) {
        return localStorage.getItem(LS_KEY);
    }
    return null;
}
